import React from 'react';
import { Link } from 'react-router-dom';
import { FaUsers, FaCalendarAlt, FaChartBar, FaChartLine, FaHandshake, FaTrash } from 'react-icons/fa';
import './ApiButtonsVisualization.css';

const ApiButtonsVisualization = () => {
  const handleClearCache = () => {
    // Clear localStorage cache
    console.log('Clearing localStorage cache...');
    localStorage.clear();
    
    // Clear indexedDB if it's used
    if (window.indexedDB) {
      console.log('Clearing indexedDB...');
      const databases = indexedDB.databases ? indexedDB.databases() : [];
      databases.then(dbs => {
        dbs.forEach(db => {
          indexedDB.deleteDatabase(db.name);
        });
      }).catch(err => {
        console.error('Error clearing indexedDB:', err);
      });
    }
    
    // Clear session storage
    console.log('Clearing sessionStorage...');
    sessionStorage.clear();
    
    // Attempt to clear browser cache through Service Worker (if available)
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
          console.log(`Cache ${cacheName} deleted`);
        });
      });
    }
      
    console.log('Cache cleared.');
    alert('Кэш успешно очищен! Обновите страницу для применения изменений.');
    
    // Reload the page to refresh all data
    window.location.reload();
  };

  return (
    <div className="api-buttons">
      <Link to="/standings" className="api-button">
        <FaChartBar className="api-button-icon" />
        <span className="api-button-text">Standings</span>
      </Link>
      <Link to="/statistics" className="api-button">
        <FaChartLine className="api-button-icon" />
        <span className="api-button-text">Statistics</span>
      </Link>
      {/* <button onClick={handleClearCache} className="api-button cache-clear-btn">
        <FaTrash className="api-button-icon cache-icon" />
        <span className="api-button-text">Очистить кэш</span>
      </button> */}
    </div>
  );
};

export default ApiButtonsVisualization; 